function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withModifiers } from '../../decorators';

var StatusIcon = function StatusIcon(_ref) {
  var className = _ref.className,
      name = _ref.name,
      status = _ref.status,
      others = _objectWithoutProperties(_ref, ["className", "name", "status"]);

  var ancestorClasses = classNames('icon has-text-grey is-ancestor has-status', className);
  var descendantClasses = classNames('icon is-circled is-descendant is-bottom', {
    'is-success': status === 'success',
    'is-warning': status === 'warning'
  });
  var descendantIcon = status === 'success' ? 'tri-ui-check-circle-s' : 'tri-ui-times-circle-s';
  return React.createElement("span", _extends({
    className: ancestorClasses,
    "aria-hidden": "true"
  }, others), React.createElement("span", {
    className: "tri-".concat(name)
  }, React.createElement("span", {
    className: descendantClasses
  }, React.createElement("span", {
    className: descendantIcon
  }))));
};

StatusIcon.propTypes = {
  name: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  className: PropTypes.string
};
export default withModifiers(StatusIcon);